'use strict';

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

ScenarioConfig=class ScenarioConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('scenario',{
views:{
"breadcrumbs@":{
templateUrl:`/templates/layout/breadcrumbs`}},


params:{
personInfo:null,
originalInputs:null,
schedule:null,
route:null,
fatigueThreshold:null,
queryInterval:null}});


$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=ScenarioConfig;
//# sourceMappingURL=scenarioConfig.js.map
